'use strict';

const EMPTY_STORAGE_DATA = '{}';
const SHARED_PAGE_HISTORY_KEY = 'page-history';
const SHARED_SESSION_STORAGE_KEY = 'cytric-shared-session';

function local(key, value)
{
    const pageName = document.documentElement.dataset.page,
          pageData = JSON.parse(localStorage.getItem(pageName) || EMPTY_STORAGE_DATA);
    if (value !== undefined) {
        pageData[key] = value;
        localStorage.setItem(pageName, JSON.stringify(pageData));
    } else {
        return pageData[key];
    }
}

function session(key, value)
{
    const pageName = document.documentElement.dataset.page,
          pageData = JSON.parse(sessionStorage.getItem(pageName) || EMPTY_STORAGE_DATA);
    if (value !== undefined) {
        pageData[key] = value;
        sessionStorage.setItem(pageName, JSON.stringify(pageData));
    } else {
        return pageData[key];
    }
}

function readSharedSession()
{
    try {
        const sharedData = JSON.parse(sessionStorage.getItem(SHARED_SESSION_STORAGE_KEY) || EMPTY_STORAGE_DATA);
        return sharedData && typeof sharedData === 'object' && !Array.isArray(sharedData) ? sharedData : {};
    } catch (e) {
        return {};
    }
}

function writeSharedSession(sharedData)
{
    try {
        if (Object.keys(sharedData).length) {
            sessionStorage.setItem(SHARED_SESSION_STORAGE_KEY, JSON.stringify(sharedData));
        } else {
            sessionStorage.removeItem(SHARED_SESSION_STORAGE_KEY);
        }
    } catch (e) {
        // Browser storage is optional; callers continue without cross-page state.
    }
}

function sharedSession(key, value)
{
    const sharedData = readSharedSession();
    if (value !== undefined) {
        sharedData[key] = value;
        writeSharedSession(sharedData);
    } else {
        return sharedData[key];
    }
}

function removeSharedSession(key)
{
    const sharedData = readSharedSession();
    delete sharedData[key];
    writeSharedSession(sharedData);
}

function trackPage(pageName)
{
    const sharedData = readSharedSession(),
          pageHistory = sharedData[SHARED_PAGE_HISTORY_KEY] || {};
    if (pageName && pageHistory.current !== pageName) {
        pageHistory.previous = pageHistory.current;
        pageHistory.current = pageName;
        sharedData[SHARED_PAGE_HISTORY_KEY] = pageHistory;
        writeSharedSession(sharedData);
    }
}

function previousPage()
{
    const pageHistory = readSharedSession()[SHARED_PAGE_HISTORY_KEY];
    return pageHistory && pageHistory.previous;
}

const page = {local, session},
      shared = {
          session: sharedSession,
          removeSession: removeSharedSession,
          trackPage,
          previousPage
      };

export default { page, shared }
